
// import video from '../assets/video/example.mp4'
import video from '../assets/video/video.mov'

export default function Video() {
  return (
    <video className="h-screen w-full object-cover dark:brightness-75 brightness-100" 
      autoPlay 
      muted 
      playsInline
      preload="auto"
      >
      <source src={video} type="video/mp4" />
      Your browser does not support the video tag.
    </video>

  );
}
